import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import Button from "../../../componentsv2/Button";
import {
  arquivoEhImagem,
  arquivoEhPdf,
  normalizarArquivoPrescricao,
} from "../utils/prescricaoArquivos";

export default function ModalPreviewPrescricao({
  open,
  loading,
  arquivo,
  blobUrl,
  onClose,
  onDownload,
}) {
  if (!open) return null;

  const arquivoNormalizado = arquivo ? normalizarArquivoPrescricao(arquivo) : null;
  const nomeArquivo = arquivoNormalizado?.nomeOriginal || "Prescrição";
  const podeVisualizarPdf = arquivoNormalizado && arquivoEhPdf(arquivoNormalizado);
  const podeVisualizarImagem = arquivoNormalizado && arquivoEhImagem(arquivoNormalizado);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        {nomeArquivo}
        <IconButton
          aria-label="Fechar preview"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {loading && (
          <div style={{ minHeight: "420px", display: "grid", placeItems: "center" }}>
            Carregando arquivo...
          </div>
        )}

        {!loading && blobUrl && podeVisualizarPdf && (
          <iframe
            src={blobUrl}
            title={`Visualizar ${nomeArquivo}`}
            style={{
              width: "100%",
              height: "72vh",
              border: "1px solid #ECEFF1",
              borderRadius: "8px",
            }}
          />
        )}

        {!loading && blobUrl && podeVisualizarImagem && (
          <div
            style={{
              minHeight: "420px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#FAFAFA",
              border: "1px solid #ECEFF1",
              borderRadius: "8px",
              overflow: "auto",
            }}
          >
            <img
              src={blobUrl}
              alt={nomeArquivo}
              style={{
                maxWidth: "100%",
                maxHeight: "72vh",
                objectFit: "contain",
              }}
            />
          </div>
        )}

        {!loading && (!blobUrl || (!podeVisualizarPdf && !podeVisualizarImagem)) && (
          <div style={{ minHeight: "300px", display: "grid", placeItems: "center" }}>
            Não foi possível visualizar este arquivo.
          </div>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button type="button" color="gray" variant="outlined" onClick={onClose}>
          Fechar
        </Button>
        <Button
          type="button"
          color="blue"
          variant="contained"
          disabled={!blobUrl}
          onClick={onDownload}
        >
          Baixar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
